module.exports = __webpack_public_path__ + "img/jyhd-dabiao@3x.b51589c1.png";